/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SalesChannel } from './SalesChannel';
import {
    SalesChannelFromJSON,
    SalesChannelFromJSONTyped,
    SalesChannelToJSON,
} from './SalesChannel';
import type { GameBranding } from './GameBranding';
import {
    GameBrandingFromJSON,
    GameBrandingFromJSONTyped,
    GameBrandingToJSON,
} from './GameBranding';
import type { RaffleStatus } from './RaffleStatus';
import {
    RaffleStatusFromJSON,
    RaffleStatusFromJSONTyped,
    RaffleStatusToJSON,
} from './RaffleStatus';

/**
 * Basic raffle game information
 * @export
 * @interface RaffleGame
 */
export interface RaffleGame {
    /**
     * Optional logo image URL for the game
     * @type {string}
     * @memberof RaffleGame
     * @deprecated
     */
    logoUrl?: string | null;
    /**
     * Presentation/branding metadata (logo, special ball color)
     * @type {GameBranding}
     * @memberof RaffleGame
     */
    branding?: GameBranding | null;
    /**
     * 
     * @type {string}
     * @memberof RaffleGame
     */
    gameId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RaffleGame
     */
    activeTo?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RaffleGame
     */
    activeFrom: Date;
    /**
     * 
     * @type {number}
     * @memberof RaffleGame
     */
    remainingTickets?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RaffleGame
     */
    totalTickets?: number | null;
    /**
     * 
     * @type {RaffleStatus}
     * @memberof RaffleGame
     */
    status: RaffleStatus;
    /**
     * 
     * @type {number}
     * @memberof RaffleGame
     */
    ticketCostInCents: number;
    /**
     * 
     * @type {SalesChannel}
     * @memberof RaffleGame
     */
    salesChannel: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof RaffleGame
     */
    name: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof RaffleGame
     */
    customerId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof RaffleGame
     */
    id: string;
}



/**
 * Check if a given object implements the RaffleGame interface.
 */
export function instanceOfRaffleGame(value: object): value is RaffleGame {
    if (!('activeFrom' in value) || value['activeFrom'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('ticketCostInCents' in value) || value['ticketCostInCents'] === undefined) return false;
    if (!('salesChannel' in value) || value['salesChannel'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function RaffleGameFromJSON(json: any): RaffleGame {
    return RaffleGameFromJSONTyped(json, false);
}

export function RaffleGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): RaffleGame {
    if (json == null) {
        return json;
    }
    return {
        
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'branding': json['branding'] == null ? undefined : GameBrandingFromJSON(json['branding']),
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'activeTo': json['activeTo'] == null ? undefined : (new Date(json['activeTo'])),
        'activeFrom': (new Date(json['activeFrom'])),
        'remainingTickets': json['remainingTickets'] == null ? undefined : json['remainingTickets'],
        'totalTickets': json['totalTickets'] == null ? undefined : json['totalTickets'],
        'status': RaffleStatusFromJSON(json['status']),
        'ticketCostInCents': json['ticketCostInCents'],
        'salesChannel': SalesChannelFromJSON(json['salesChannel']),
        'name': json['name'],
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function RaffleGameToJSON(value?: RaffleGame | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'logoUrl': value['logoUrl'],
        'branding': GameBrandingToJSON(value['branding']),
        'gameId': value['gameId'],
        'activeTo': value['activeTo'] == null ? undefined : ((value['activeTo'] as any).toISOString()),
        'activeFrom': ((value['activeFrom']).toISOString()),
        'remainingTickets': value['remainingTickets'],
        'totalTickets': value['totalTickets'],
        'status': RaffleStatusToJSON(value['status']),
        'ticketCostInCents': value['ticketCostInCents'],
        'salesChannel': SalesChannelToJSON(value['salesChannel']),
        'name': value['name'],
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

